import React from 'react';

import ProjectHistoryData from './ProjectHistoryData';
import ProjectHistoryEntry from './ProjectHistoryEntry';

class ProjectHistoryList extends React.Component {

    constructor() {
        super();

        this.data = new ProjectHistoryData();
//        this.projhist = this.data.getFilteredData([], [], []);


    }

    render() {

        var itemListStyle = {
            textAlign: "left",
            padding: 0,
            marginTop: 15,
        }

        var hideCountStyle ={
            height: 0,
        }

        var showCountStyle = {
            height: "auto",
            fontSize: 12,
        }

        console.log("Filter Dump: " + JSON.stringify(this.props, null, 4));

        var histlist = this.data.getFilteredData(this.props.filters.industries, this.props.filters.andTechs, this.props.filters.techs, this.props.filters.andSearch, this.props.filters.search);
        var totalprojcount = this.data.getTotalProjectCount();
        var countString = "";
        var displayCountStyle = hideCountStyle;
        if(this.props.displaycount) {
            countString = "displaying " +  histlist.length + " of " + totalprojcount + " total projects :";
            displayCountStyle = showCountStyle;
        }
        return (
            <section>
                <div style={displayCountStyle}>{countString}</div>
                <section style={itemListStyle}>

                    {histlist.map((project) =>
                        <ProjectHistoryEntry project={project} />
                    )}

                </section>

            </section>
        );
    }
}

export default ProjectHistoryList


// WEBPACK FOOTER //
// src/ProjectHistory/ProjectHistoryList.js